import * as React from 'react';

import {CalendarListItem} from 'shells/scheduler/multiple-conflict-calendars/calendar-list-item';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import type {GetCalendars_calendars as Calendar} from 'nutshell-graphql-types';

import {getDisabledDataTipText} from './helpers';

type Props = {
    calendars: Calendar[];
    selectedCalendarId: string | null | undefined;
    onSelectCalendar: (calendarId: string) => void;
    modalType: 'sync' | 'conflict';
    menuMaxHeight?: number;
};

export function CalendarList(props: Props) {
    const {menuMaxHeight = 200} = props;

    const options = props.calendars
        .map((calendar) => {
            const isDisabled =
                (calendar.syncType === 'CONFLICT' && !calendar.isSelected) ||
                (props.modalType === 'conflict' && calendar.syncType === 'PRIMARY');

            return {
                calendar,
                isDisabled,
                value: calendar.id,
                label: calendar.name,
                serviceType: calendar.serviceType,
                syncErrors: calendar.syncErrors,
            };
        })
        .sort((a, b) => Number(a.isDisabled) - Number(b.isDisabled));

    const selectedOption = options.find((opt) => opt.value === props.selectedCalendarId);

    // @ts-expect-error
    const formatOptionLabel = (option) => {
        const tooltipText = option.isDisabled
            ? getDisabledDataTipText(option.calendar, props.modalType)
            : null;

        return (
            // @ts-expect-error
            <div title={tooltipText}>
                <CalendarListItem
                    name={option.label}
                    size='normal'
                    externalService={option.serviceType === 'OFFICE365' ? 'OFFICE365' : 'GOOGLE'}
                    syncErrors={option.syncErrors}
                />
            </div>
        );
    };

    // @ts-expect-error
    const isOptionDisabled = (option) => option.isDisabled;

    return (
        <SelectPickerGeneric
            options={options}
            value={selectedOption}
            // @ts-expect-error
            onChange={(newValue) => props.onSelectCalendar(newValue.value)}
            placeholder='Select a calendar'
            formatOptionLabel={formatOptionLabel}
            isOptionDisabled={isOptionDisabled}
            isClearable={false}
            isSearchable={false}
            maxMenuHeight={menuMaxHeight}
            minHeight={40}
        />
    );
}
